// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3dytA","form":"styles_form__2t-bm"};